import type { ImageLoader } from 'next/image';

export const CalmSleepLogoColor = { White: 'White', Gradient: 'Gradient' } as const;
type CalmSleepLogoColorType = (typeof CalmSleepLogoColor)[keyof typeof CalmSleepLogoColor];

export interface CalmSleepLogoProps {
	className?: string;
	height?: number;
	href?: string;
	color?: CalmSleepLogoColorType;
	loader?: ImageLoader;
	preserveQueryParams?: boolean;
	'aria-label'?: string;
	'data-testid'?: string;
}
